import { API } from "@/lib/api";

const KEY = "cm-consent";

let state = null;
try {
  state = JSON.parse(localStorage.getItem(KEY) || "null");
} catch (e) {}

const listeners = new Set();

export function getConsent() {
  return state;
}

export function setConsent(decision) {
  state = {
    decision,
    personalized: decision === "accepted",
    ts: new Date().toISOString(),
  };
  try {
    localStorage.setItem(KEY, JSON.stringify(state));
  } catch (e) {}
  listeners.forEach((l) => l());
  try {
    let vid = localStorage.getItem("cm-vid");
    if (!vid) {
      vid = crypto.randomUUID();
      localStorage.setItem("cm-vid", vid);
    }
    fetch(`${API}/consent`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        visitor_id: vid,
        ads_allowed: decision === "accepted",
        personalized: decision === "accepted",
      }),
    }).catch(() => {});
  } catch (e) {}
}

export function resetConsent() {
  state = null;
  try {
    localStorage.removeItem(KEY);
  } catch (e) {}
  listeners.forEach((l) => l());
}

export function subscribeConsent(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
